import {Stack, Typography} from '@mui/material';
import React from 'react';
import {isNullOrEmpty} from 'src/utils/helperMethods';
import Row from 'src/components/ui/Row';
import CopyButton from 'src/components/buttons/CopyButton';
import StyledLink from 'src/components/ui/StyledLink';

const bgcolor = '#EDEEF4';
export default function OrderCustomerDetails({order}) {
	const {phone_country_code = '+218'} = order;
	return !isNullOrEmpty(order.customer) ? (
		<>
			<Row bgcolor={bgcolor} label="الاسم" value={order.customer?.name || 'لم يتم ادخال الاسم'} />
			{order.user && (
				<StyledLink to={`/customers/${order.user.id}`}>
					<Typography textAlign="end">حساب العميل</Typography>
				</StyledLink>
			)}
			{/* phone number */}
			{!isNullOrEmpty(order.customer.phone) && (
				<Row
					bgcolor={bgcolor}
					label="رقم الهاتف"
					value={
						<Stack direction={'row'} alignItems="center" spacing={1}>
							<a
								className="hover-effect"
								style={{
									textDecoration: 'none',
									color: '#515151',
									border: 'solid 0.3px #515151',
									padding: '2px 6px',
									fontSize: 14,
									borderRadius: 10,
									direction: 'ltr',
								}}
								href={`tel://${phone_country_code}${order.customer.phone}`}
							>
								اتصال {`${order.customer.phone}`}
								{/* اتصال {`${phone_country_code}${order.customer.phone}`} */}
							</a>
							<a
								className="hover-effect"
								style={{
									textDecoration: 'none',
									color: '#25D366',
									border: 'solid 0.3px #25D366',
									padding: '4px 6px',
									fontSize: 14,
									borderRadius: 10,
									direction: 'ltr',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
								href={`https://wa.me/${phone_country_code.replace('+', '')}${order.customer.phone}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src="/whatsapp.png" alt="WhatsApp" style={{width: 16, height: 16}} />
							</a>
							<CopyButton value={`${phone_country_code}${order.customer.phone}`} />
						</Stack>
					}
				/>
			)}
			{!isNullOrEmpty(order.custom_fields?.phone2) && (
				<Row
					label="رقم هاتف - احتياطي"
					value={
						<Stack direction={'row'} alignItems="center" spacing={1}>
							<a
								className="hover-effect"
								style={{
									textDecoration: 'none',
									color: '#515151',
									border: 'solid 0.3px #515151',
									padding: '2px 6px',
									fontSize: 14,
									borderRadius: 10,
									direction: 'ltr',
								}}
								href={`tel://+218${order.custom_fields?.phone2}`}
							>
								اتصال {`${order.custom_fields?.phone2}`}
								{/* اتصال {`${phone_country_code}${order.customer.phone}`} */}
							</a>
							<a
								className="hover-effect"
								style={{
									textDecoration: 'none',
									color: '#25D366',
									border: 'solid 0.3px #25D366',
									padding: '4px 6px',
									fontSize: 14,
									borderRadius: 10,
									direction: 'ltr',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
								href={`https://wa.me/218${order.custom_fields?.phone2}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src="/whatsapp.png" alt="WhatsApp" style={{width: 16, height: 16}} />
							</a>
							<CopyButton value={`+218${order.custom_fields?.phone2}`} />
						</Stack>
					}
				/>
			)}
		</>
	) : (
		<Typography variant="body" color="error">
			لم يتم العثور علي بيانات الزبون
		</Typography>
	);
}
